namespace TabAurous.Finance {
    export interface PartyBalanceForm {
        TransDate: Serenity.DateEditor;
        LedgerId: Serenity.DecimalEditor;
        VoucherTypeId: Serenity.DecimalEditor;
        VoucherNo: Serenity.StringEditor;
        AgainstVoucherTypeId: Serenity.DecimalEditor;
        AgainstVoucherNo: Serenity.StringEditor;
        InvoiceNo: Serenity.StringEditor;
        AgainstInvoiceNo: Serenity.StringEditor;
        ReferenceType: Serenity.StringEditor;
        Debit: Serenity.DecimalEditor;
        Credit: Serenity.DecimalEditor;
        CreditPeriod: Serenity.IntegerEditor;
        ExchangeRate: Serenity.DecimalEditor;
        FinancialYearId: Serenity.DecimalEditor;
    }

    export class PartyBalanceForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.PartyBalance';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PartyBalanceForm.init)  {
                PartyBalanceForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;

                Q.initFormType(PartyBalanceForm, [
                    'TransDate', w0,
                    'LedgerId', w1,
                    'VoucherTypeId', w1,
                    'VoucherNo', w2,
                    'AgainstVoucherTypeId', w1,
                    'AgainstVoucherNo', w2,
                    'InvoiceNo', w2,
                    'AgainstInvoiceNo', w2,
                    'ReferenceType', w2,
                    'Debit', w1,
                    'Credit', w1,
                    'CreditPeriod', w3,
                    'ExchangeRate', w1,
                    'FinancialYearId', w1
                ]);
            }
        }
    }
}
